import React, { useState } from 'react';
import {
  Button, Col, Radio, Row
} from '@thd-olt-component-react/core-ui';
import PropTypes from 'prop-types';
import { MobileAwareOverlay } from '../../../components/MobileAwareOverlay';
import { AddressType } from './types';
import './confirmAddressModal.scss';
import {
  IconWithRoundBorder
} from '../IconWithRoundBorder/IconWithRoundBorder';
import { formatAddress } from './common';
import { addAnalyticEvent } from '../../analytics/common';
import { confirmMailingEvent, unverifiedMailingEvent } from '../../analytics/address';
import LinkButton from '../LinkButton';

export const SelectAddressModal = ({
  isMobile, handleClose, openAddressEntryModal, verifiedAddress, address, useVerifiedAddress,
  unsubscribeVerifiedAddress, unsubscribeAddress
}) => {

  const [verifiedAddressSelected, setVerifiedAddressSelected] = useState(useVerifiedAddress);

  const handleConfirmClick = () => {
    if (verifiedAddressSelected) {
      addAnalyticEvent(confirmMailingEvent);
      unsubscribeVerifiedAddress();
    } else {
      addAnalyticEvent(unverifiedMailingEvent);
      unsubscribeAddress();
    }
  };

  return (
    <MobileAwareOverlay
      modalClass="preferences-modal"
      onClose={handleClose}
      open
    >
      <Row className="preferences-modal__content">
        <Col>
          <Row>
            <Col className="modal-title modal-title--with-round-icon">
              {!isMobile && (
                <IconWithRoundBorder
                  iconSrc="https://assets.homedepot-static.com/images/v1/mailbox.svg"
                  iconWidth="27.7px"
                />
              )}
              <h1>Confirm Your Mailing Address</h1>
            </Col>
          </Row>
          <Row className="text">
            <Col className="epc-bold-text">
              The address entered matched the verified address provided by United Parcel
              Service (UPS). The Home Depot recommends using the Verified Address option.
              We may not be able to remove the Unverified Address you entered because it
              may be invalid.
            </Col>
          </Row>
          <Row>
            <Col>
              <h3>
                Please confirm the correct address or{' '}
                <LinkButton onClick={openAddressEntryModal} testId="unverified-try-again">
                  try again
                </LinkButton>
                .
              </h3>
            </Col>
          </Row>
          <h3><strong>Verified Mailing Address</strong></h3>
          <Row>
            <Col>
              <Radio
                className="radio-container col__12-12"
                id="verifiedAddress"
                checked={verifiedAddressSelected}
                value={verifiedAddressSelected}
                formName="verifyAddress"
                onChange={() => { setVerifiedAddressSelected(true); }}
              >
                {formatAddress(verifiedAddress)}
              </Radio>
            </Col>
          </Row>
          <br />
          <h3><strong>Unverified Mailing Address</strong></h3>
          <Row>
            <Col>
              <Radio
                className="radio-container col__12-12"
                id="unverifiedAddress"
                checked={!verifiedAddressSelected}
                value="unverifiedAddress" /* What is the issue here? */
                formName="verifyAddress"
                onChange={() => { setVerifiedAddressSelected(false); }}
              >
                {formatAddress(address)}
              </Radio>
            </Col>
          </Row>
          <hr className="hr-line" />
          <Row>
            <Col nopadding md={8} />
            <Col md={4}>
              <Button onClick={handleConfirmClick}>Confirm</Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </MobileAwareOverlay>
  );
};

SelectAddressModal.propTypes = {
  isMobile: PropTypes.bool,
  unsubscribeAddress: PropTypes.func.isRequired,
  unsubscribeVerifiedAddress: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  openAddressEntryModal: PropTypes.func.isRequired,
  verifiedAddress: AddressType.isRequired,
  address: AddressType.isRequired,
  useVerifiedAddress: PropTypes.bool.isRequired,
};

SelectAddressModal.defaultProps = {
  isMobile: false,
};
